// Rekap A4 gabungan Shopee + Tokopedia + Offline (hari ini / besok). Owner & Rido memakai PDF yang sama. Baca-saja.
import React, { useState } from "react";
import axios from "axios";
import { FileDown } from "lucide-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/production/monitoring`;
const wibDate = (days) => new Date(Date.now() + days * 86400000)
  .toLocaleDateString("id-ID", { timeZone: "Asia/Jakarta", day: "2-digit", month: "short" });

function PdfButton({ path, label, days, testid, fallback, compact }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const download = async () => {
    setBusy(true); setErr("");
    try {
      const r = await axios.get(`${BASE}/${path}`, { responseType: "blob", withCredentials: true });
      const name = /filename="?([^"]+)"?/.exec(r.headers["content-disposition"] || "")?.[1] || fallback;
      const url = window.URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(() => window.URL.revokeObjectURL(url), 2000);
    } catch (e) { setErr("Gagal membuat PDF. Coba lagi."); }
    finally { setBusy(false); }
  };
  return <div className="pm-shiptoday-item">
    <button type="button" className={`pm-shiptoday-btn${days ? " is-ahead" : ""}`} onClick={download} disabled={busy} data-testid={testid}
      title={compact ? `Rekap Shopee · Tokopedia · Offline — ${wibDate(days)} (WIB)` : undefined}>
      <FileDown size={compact ? 16 : 18}/>
      <span className="pm-shiptoday-txt">{busy ? "Menyiapkan PDF…" : label}<small data-testid={`${testid}-date`}>{compact ? "PDF A4" : `Shopee · Tokopedia · Offline — ${wibDate(days)} (WIB)`}</small></span>
    </button>
    {err && <span className="pm-shiptoday-err" role="alert" data-testid={`${testid}-error`}>{err}</span>}
  </div>;
}

export function ShipTodayPdfButton({ compact = false }) {
  return <div className={`pm-shiptoday${compact ? " is-compact" : ""}`}>
    <PdfButton path="shopee-ship-today.pdf" label={compact ? "Kirim Hari Ini" : "Rekap Kirim Hari Ini — PDF A4"} days={0} testid="ship-today-pdf-btn" fallback="rekap-kirim.pdf" compact={compact}/>
    <PdfButton path="shopee-ship-tomorrow.pdf" label={compact ? "Kirim Besok" : "Rekap Kirim Besok — PDF A4"} days={1} testid="ship-tomorrow-pdf-btn" fallback="rekap-kirim-besok.pdf" compact={compact}/>
  </div>;
}
